export default __webpack_public_path__ + "static/family-tv-8E6152AD1267-d2ffedb1545f997e84ddec6f32f51e4d.jpg";